import i18n from '@i18next/i18n';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import Modal from '@tencent/dui/lib/components/Modal';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import type { IDeleteCommentFeature } from './delete-comment-interface';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

@Feature()
export class DeleteCommentFeature extends BaseToolbarFeature implements IDeleteCommentFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleDeleteCommentGroupClick(): void {
        Modal.confirm({
            title: i18n.t('删除批注'),
            content: i18n.t('删除后，该批注下方的回复也将消失。确认删除吗？'),
            okButtonType: 'warning',
            okText: i18n.t('删除'),
            onOk: () => {
                this.getCommentManager()?.promise()
                    .then((commentManager) => {
                        commentManager.activeGroupId && commentManager.deleteCommentGroup(commentManager.activeGroupId);
                    });
                this.report(TDWActionType.DELETE_COMMENTS, EventCodeType.DOC_PPT_REVIEW_TAB_DELETE_COMMENTS);
            },
        });
    }

    public handleDeletePageCommentClick(): void {
        Modal.confirm({
            title: i18n.t('删除批注'),
            content: i18n.t('删除后，当前页面所有的批注都将清除，确认删除吗？'),
            okButtonType: 'warning',
            okText: i18n.t('删除'),
            onOk: () => {
                this.getCommentManager()?.promise()
                    .then((commentManager) => {
                        commentManager.deletePageComment();
                    });
                this.report(TDWActionType.DELETE_PAGE_COMMENTS, EventCodeType.DOC_PPT_REVIEW_TAB_DELETE_PAGE_COMMENTS);
            },
        });
    }

    public handleDeleteAllCommentClick(): void {
        Modal.confirm({
            title: i18n.t('删除批注'),
            content: i18n.t('删除后，整个文档所有的批注都将清除，确认删除吗？'),
            okButtonType: 'warning',
            okText: i18n.t('删除'),
            onOk: () => {
                this.getCommentManager()?.promise()
                    .then((commentManager) => {
                        commentManager.deleteAllComment();
                    });
                this.report(TDWActionType.DELETE_ALL_COMMENTS, EventCodeType.DOC_PPT_REVIEW_TAB_DELETE_ALL_COMMENTS);
            },
        });
    }

    public shouldDeleteCommentGroupDisabled(): boolean {
        const commentManager = this.getCommentManager()?.dangerousInstance;
        if (!commentManager) return true;
        // 未打开侧边栏或者未选中任意批注组的情况下，置灰
        if (!commentManager.isCommentDrawerShown || !commentManager.activeGroupId) {
            return true;
        }
        return !commentManager?.isCommentGroupOwner(commentManager.activeGroupId);
    }

    public shouldDeletePageCommentGroupDisabled(): boolean {
        const currentSlide = this.getSelectionService()?.currentSlide;
        return !currentSlide?.commentGroupMap?.size;
    }

    protected getCustomDisabledState() {
        const count = this.getCommentManager().dangerousInstance?.getCommentCount();
        return !count;
    }

    private getCommentManager = () => this.getAppService().viewableServiceLayer.commentManager;

    private report(action, eventcode) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_REVIEW_TAB,
            ver3: 1,    // menu
            ver5: this.getSelectModel()?.type,
            action,
            eventcode,
        });
    }
}
